import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import FalseRoute from "../common/FalseRoute";
import PaymentStatus from "../views/payment-status/payment-status";

// Lazy load all views
const Main = lazy(() => import("../views/LandingPg/Main"));
const About = lazy(() => import("../views/About us/About"));
const Gallery = lazy(() => import("../views/gallery/gallery"));

const AdminAttendance = lazy(() =>  import("../views/admin_attendance/AdminAttendance"));
const AttendanceBoard = lazy(() =>  import("../views/attendance_board/AttendanceBoard"));
const SocialMediaAdmin = lazy(() => import("../views/admin_social/SocialMediaAdmin"));

const VoicemastersSundayClub = lazy(() => import("../views/public_speaking/public-speaking-sunday-club"));
const VoicemastersSaturdayClub = lazy(() => import("../views/public_speaking/public-speaking-saturday-jr-club"));
const VoicemastersSaturdaySrClub = lazy(() => import("../views/public_speaking/public-speaking-saturday-seniors-club"));
const VoiceMastersLanding = lazy(() => import("../views/public_speaking_all/public-speaking"));
const VoicemastersPlus = lazy(() => import("../views/public_speaking/public-speaking-voicemasters-plus"));
const Library = lazy(() => import("../views/library/library"));
const Science = lazy(() => import("../views/summercamp/science"));
const ScienceLanding = lazy(() => import("../views/science/science-landing"));
const Sudoku = lazy(() => import("../views/sudoku/sudoku"));
const OlympiadFinalist = lazy(() => import("../views/olympiad/olympiad"));
const RoboticsLanding = lazy(() => import("../views/robotics/robotics-landing"));
const RoboticsSenior = lazy(() => import("../views/robotics/robotics-senior"));
const RoboticsJunior = lazy(() => import("../views/robotics/robotics-junior"));
const Finance = lazy(() => import("../views/finance/finance"));
const ThreedPrintingLanding = lazy(() => import("../views/3d-printing/3d-printing-for-children"));
const Careers = lazy(() => import("../views/careers/careers"));
const Terms = lazy(() => import("../views/terms/terms"));
const Bday = lazy(() => import("../views/bday/bday"));
const Camp24 = lazy(() => import("../views/summercamp24/camp24"));
const SummerCampLanding = lazy(() => import("../views/SummerCampLanding/landing2026"));
const OnlineRoboticsLanding = lazy(() => import("../views/OnlineRobotics/online-robotics-landing"));
// const SummerCampLanding = lazy(() => import("../views/SummerCampLanding/landing"));
const VoiceMasterLeaderboard = lazy(() => import("../views/public_speaking/VoiceMasterLeaderboard"));
const Blog = lazy(() => import("../views/blog/blog-landing-page"));
const WhyRoboticsProblemSolving = lazy(() => import("../views/blog/what-is-robotics-for-kids"));
const PublicSpeakingParentsBlog = lazy(() => import("../views/blog/parenting-tips-for-public-speaking"));
const PublicSpeakingBlog = lazy(() => import("../views/blog/public-speaking-for-kids"));
const LegoRoboticsBlog = lazy(() => import("../views/blog/lego-robotics-for-children"));
const SilentCrisisBlog = lazy(() => import("../views/blog/silent-crisis-facing-our-children"));
const CancellationRefunds = lazy(() => import("../views/terms/refunds"));
const PrivacyPolicy = lazy(() => import("../views/terms/privacy"));
const WhyFinancialLiteracyForKids = lazy(() => import("../views/blog/why-financial-literacy-for-kids"));
const ScriptEvaluator = lazy(() => import("../views/script_evaluator/ScriptEvaluator"));
const DataScience = lazy(() => import("../views/data-science/data-science"));
const DataScienceTeaser = lazy(() => import("../views/LandingPg/data-science-teaser"));
const Enroll = lazy(() => import("../views/enroll/enroll"));
const OcrTest = lazy(() => import("../views/pages/OcrTest"));
const SummerCampForChildrenBlog = lazy(() => import("../views/blog/summer-camp-for-children"));



function MainRoutes() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* <Route path="/public-speaking-juniors" element={<VoiceJ />} /> */}
        <Route path="/public-speaking-for-children" element={<VoiceMastersLanding />} />
        <Route path="/public-speaking-voicemasters-plus" element={<VoicemastersPlus />} />
        <Route path="/library" element={<Library />} />
        <Route path="/science" element={<Science />} />
        <Route path="/science-classes" element={<ScienceLanding />} />
        <Route path="/sudoku" element={<Sudoku />} />
        <Route path="/olympiad" element={<OlympiadFinalist />} />
        <Route path="/robotics-for-children" element={<RoboticsLanding />} />
        <Route path="/script-evaluator" element={<ScriptEvaluator />} />
        <Route path="/robotics/senior" element={<RoboticsSenior />} />
        <Route path="/robotics/junior" element={<RoboticsJunior />} />
        <Route path="/finance-for-kids" element={<Finance />} />
        <Route path="/3d-printing-for-children" element={<ThreedPrintingLanding />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/bday" element={<Bday />} />
        <Route path="/camp24" element={<Camp24 />} />
        <Route path="/summer-camp" element={<SummerCampLanding />} />
        <Route path="/online-robotics" element={<OnlineRoboticsLanding />} />
        <Route path="/voicemasters-leaderboard" element={<VoiceMasterLeaderboard />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="blog/what-is-robotics-for-kids" element={<WhyRoboticsProblemSolving />} />
        <Route path="blog/parenting-tips-for-public-speaking" element={<PublicSpeakingParentsBlog />} />
        <Route path="blog/public-speaking-for-kids" element={<PublicSpeakingBlog />} />
        <Route path="blog/lego-robotics-for-children" element={<LegoRoboticsBlog />} />
        <Route path="blog/silent-crisis-facing-our-children" element={<SilentCrisisBlog />} />
        <Route path="blog/why-financial-literacy-for-kids" element={<WhyFinancialLiteracyForKids />} />
        <Route path="/cancellation-refunds" element={<CancellationRefunds />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/data-science" element={<DataScience />} />
        <Route path="/data-science-teaser" element={<DataScienceTeaser />} />
        <Route path="/enroll" element={<Enroll />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/public-speaking-sunday-club" element={<VoicemastersSundayClub />} />
        <Route path="/public-speaking-saturday-seniors-club" element={<VoicemastersSaturdaySrClub />} />
        <Route path="/public-speaking-saturday-jr-club" element={<VoicemastersSaturdayClub />} />
        <Route path="/ocr-test" element={<OcrTest />} />
        <Route path="blog/summer-camp-for-children" element={<SummerCampForChildrenBlog />} />
        <Route path="*" element={<FalseRoute />} />
        <Route path="/admin/attendance" element={<AdminAttendance />}/>
        <Route path="/voicemasters/attendance" element={<AttendanceBoard />} />
        <Route path="/admin/social-media" element={<SocialMediaAdmin />}/>

      </Routes>
    </Suspense>
  );
}

export default MainRoutes;
